import { z } from 'zod'

import {
  AgreementTypeSchema,
  AgreementVersionSchema,
} from '../agreement.models.ts'
import { AgreementIdSchema } from '../unique-id.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const AgreementTermsAcceptedActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'agreement_terms_accepted',
    z.object({
      agreementId: AgreementIdSchema,
      type: AgreementTypeSchema,
      version: AgreementVersionSchema,
    })
  )
